"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showReportDialog = exports.setUserContext = exports.setExtraContext = exports.captureBreadcrumb = undefined;

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.captureException = captureException;
exports.getLogger = getLogger;
exports.install = install;

var _ravenJs = require("raven-js");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeLogger(level) {
  // Sadly, Sentry uses "warning" while browsers use "warn". Let's stick to
  // "warn".
  var ravenLevel = level === "warn" ? "warning" : level;

  return (0, _defineProperty3.default)({}, level, function (message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!this.shouldLog) {
      var _console;

      return (_console = console)[level].apply(_console, (0, _toConsumableArray3.default)(["Sentry:", message].concat(options.extra || [])));
    }

    _ravenJs2.default.captureMessage(message, (0, _extends3.default)({}, options, {
      level: ravenLevel
    }));
  });
} /**
   * Copyright 2013-present, Novivia, Inc.
   * All rights reserved.
   */

function captureException(exception) {
  // Ensure it's wrapped in an Error.
  if (!(exception instanceof Error)) {
    console.warn("Please ensure you wrap your exceptions in an 'Error' object:", exception);

    exception = new Error(exception);
  }

  return _ravenJs2.default.captureException(exception);
}

function getLogger() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { shouldLog: true },
      shouldLog = _ref2.shouldLog;

  return (0, _extends3.default)({
    shouldLog: shouldLog

  }, makeLogger("error"), makeLogger("info"), makeLogger("warn"));
}

function install() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$dsn = _ref3.dsn,
      dsn = _ref3$dsn === undefined ? "//public@sentry.novivia.com/logging" : _ref3$dsn,
      _ref3$makeRequest = _ref3.makeRequest,
      makeRequest = _ref3$makeRequest === undefined ? _ravenJs2.default._makeRequest : _ref3$makeRequest,
      _ref3$reportUnhandled = _ref3.reportUnhandledPromises,
      reportUnhandledPromises = _ref3$reportUnhandled === undefined ? true : _ref3$reportUnhandled,
      sentryConfig = (0, _objectWithoutProperties3.default)(_ref3, ["dsn", "makeRequest", "reportUnhandledPromises"]);

  if (_ravenJs2.default.isSetup()) {
    return console.warn("Logging is already enabled in the front-end. Ignoring install command.");
  }

  _ravenJs2.default.config(dsn, (0, _extends3.default)({
    autoBreadcrumbs: {
      console: true,
      dom: true,
      location: true,
      xhr: true
    },
    transport: function transport(options) {
      makeRequest((0, _extends3.default)({}, options, {
        url: "/logging"
      }));
    }
  }, sentryConfig, {
    logger: "novivia-frontend"
  })).install();

  if (reportUnhandledPromises && typeof window !== "undefined") {
    window.onunhandledrejection = function (_ref4) {
      var reason = _ref4.reason;
      return _ravenJs2.default.captureException(new Error("Promise rejected" + (reason ? ": " + reason : ".")));
    };
  }
}

var captureBreadcrumb = exports.captureBreadcrumb = _ravenJs2.default.captureBreadcrumb.bind(_ravenJs2.default);
var setExtraContext = exports.setExtraContext = _ravenJs2.default.setExtraContext.bind(_ravenJs2.default);
var setUserContext = exports.setUserContext = _ravenJs2.default.setUserContext.bind(_ravenJs2.default);
var showReportDialog = exports.showReportDialog = _ravenJs2.default.showReportDialog.bind(_ravenJs2.default);


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/logger/lib/raven/index.js
// module id = 897
// module chunks = 6